"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Organic = exports.NonOrganic = void 0;
var NonOrganic = 'Non-organic';
exports.NonOrganic = NonOrganic;
var Organic = 'Organic';
exports.Organic = Organic;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@snapask/common-components/dist/constants/appsflyerStatus.js
// module id = 628
// module chunks = 33